module.exports = __webpack_public_path__ + "static/media/S1_00031.583f7845.jpg";